import "./banner.css";

function Banner() {
  return (
    <header className="banner">
      <img src="/imagens/Banner.png" alt="Imagem do banner principal" />
    </header>
  );
}

export default Banner;
